import { Component } from '@angular/core';
import { ToastComponent } from '../core/labels/toast.component';

@Component({
  selector: 'app-sso-logged-out-page',
  imports: [ToastComponent],
  template: `
    <div class="tw-flex tw-items-center tw-p-6 ">
      <h2 class="tw-text-[30px] tw-font-bold tw-flex-1 tw-text-center">
        Logged out
      </h2>
    </div>
    <div class="tw-flex tw-justify-center tw-flex-col tw-pt-2 tw-pb-2">
      <div class="tw-flex tw-flex-col">
        <div
          class="tw-flex tw-flex-full tw-justify-center tw-w-[350px] tw-h-[200px] tw-items-center"
        >
          <app-toast type="Info"
            >You have successfully logged out of your session</app-toast
          >
        </div>
      </div>
    </div>
  `,
})
export class SsoLoggedOutPageComponent {}
